import { n as e, t } from "./createApiQueryClient-DwmsEdyU.js";
import { t as n } from "./v20240509-JTkMfURM.js";
import { t as r } from "./v20240730-CFAQYqx6.js";
import { t as i } from "./v99990101-BAnGoto_.js";
import { canadianProvinces as a, countriesAlpha2 as o, countriesAlpha2Emojis as s, getStateOptions as c, isRegionState as l, statesForCountry as u, statesWithNamesForCountry as d, toCountryLabel as f, toStateLabel as p, usStates as m } from "./utils/commonEnums/index.js";
import { _ as h, a as g, b as _, c as v, d as y, f as b, g as x, h as S, i as C, l as w, m as T, n as E, o as D, p as O, r as k, s as A, t as j, u as M, v as N, y as P } from "./utils-CjmxQ-9r.js";
import { QueryClientProvider as F } from "@tanstack/react-query";
import { PersistQueryClientProvider as I } from "@tanstack/react-query-persist-client";
import { jsx as L } from "react/jsx-runtime";
import { ReactQueryDevtools as R, ReactQueryDevtoolsPanel as z } from "@tanstack/react-query-devtools/production";
//#region src/apiQueryProvider.tsx
var B = typeof process < "u" ? "Tue Nov 03 2026 15:49:21 GMT+0000 (Coordinated Universal Time)" : void 0, V = ({ client: t, persister: n, maxAge: r = e, children: i }) => n ? /* @__PURE__ */ L(I, {
	client: t,
	persistOptions: {
		persister: n,
		maxAge: r,
		buster: B,
		dehydrateOptions: {
			shouldDehydrateMutation: () => !1,
			shouldDehydrateQuery: (e) => e.queryKey.includes("persist") && !e.queryKey.includes("legacy") && e.state.status === "success"
		}
	},
	children: i
}) : /* @__PURE__ */ L(F, {
	client: t,
	children: i
}), H = R, U = z, W = {
	dashboard20240730Client: r,
	dashboardv20240509Client: n,
	dashboardv99990101Client: i
};
//#endregion
export { H as ApiQueryDevtools, U as ApiQueryDevtoolsPanel, V as ApiQueryProvider, v as baseUseMutation, w as baseUseQuery, a as canadianProvinces, W as clients, o as countriesAlpha2, s as countriesAlpha2Emojis, t as createApiQueryClient, k as createApiQueryPersister, M as ensureQueryData, j as extractValidationErrors, y as fetchQuery, c as getStateOptions, N as isQuickBooksErrorResponse, l as isRegionState, P as isSequenceApiError, _ as isSequenceApiErrorResponse, u as statesForCountry, d as statesWithNamesForCountry, f as toCountryLabel, p as toStateLabel, m as usStates, b as useApiQueryClient, O as useComplexQuery, T as useInfiniteQuery, C as useLoadAllItems, E as useLoadAllItemsQuery, D as useMockMutation, A as useMockQuery, S as useMutation, x as useQuery, h as useRunInvalidationForMutation, g as useSequenceInfiniteQuery };

//# sourceMappingURL=index.js.map